export const USER_SIGN_IN_URL = 'sign_in';
export const USER_SIGN_OUT_URL = 'sign_out';

export const USER_SIGN_IN_MUTATION_KEY = 'sign-in';
export const USER_SIGN_OUT_MUTATION_KEY = 'sign-out';
